module.exports = __webpack_public_path__ + "img/slider_mobil-2.921bbb66.gif";